// // https://github.com/dejwid/react-tic-tac-toe

function Board(props) {
    return (
      <div className="board" {...props} />
    );
  }
  
  export default Board